import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// material-ui components
import { Button } from "@mui/material";

import styles from "../../assets/jss/material-dashboard-react/components/buttonStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";


export default function RegularButton(props) {
    const { color, round, children, disabled, simple, size, block, link, justIcon, className, muiClasses, textColor, sx, ...rest } = props;

    const targetData = {
        "button": true,
        [size]: size,
        [color]: color,
        "round": round,
        "disabled": disabled,
        "simple": simple,
        "block": block,
        "link": link,
        "justIcon": justIcon,
    };

    const keyArray = getKeyArray(targetData);

    let buttonStyle = getBaseSxStyle(styles, keyArray);

    if (sx) {
        buttonStyle = { ...buttonStyle, ...sx };
    };

    return (
        <Button sx={buttonStyle} {...rest}>
            {children}
        </Button>
    );
};

RegularButton.propTypes = {
    color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger", "rose", "white", "transparent"]),
    size: PropTypes.oneOf(["sm", "lg"]),
    simple: PropTypes.bool,
    round: PropTypes.bool,
    disabled: PropTypes.bool,
    block: PropTypes.bool,
    link: PropTypes.bool,
    justIcon: PropTypes.bool,
    className: PropTypes.string,
    // use this to pass the classes props from Material-UI
    muiClasses: PropTypes.object,
    children: PropTypes.node,
};
